import { render } from "./mini-calendar-events.vue?vue&type=template&id=a820b428"
import script from "./mini-calendar-events.vue?vue&type=script&lang=js"
export * from "./mini-calendar-events.vue?vue&type=script&lang=js"

import "./mini-calendar-events.vue?vue&type=style&index=0&id=a820b428&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__